var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_recharge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-43, -79)",
    stroke: "#0E1C39",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(45, 86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.385411,0.202527922 L2.43815107,2.34640796 C2.11321657,2.42426649 1.91292194,2.75079476 1.99078048,3.07572925 C2.01959604,3.195988 2.08457171,3.30452835 2.17695676,3.3867324 L2.66259731,3.81885449 C3.39954471,4.47458898 3.51737246,5.58303603 2.93474475,6.37904114 C-0.329537644,10.8388121 -0.870702717,15.3464034 1.31125005,19.9018154 C1.90564265,15.9360766 4.12075251,12.1682712 7.95657964,8.59839912 L9.94600067,10.7075355 C10.1752689,10.9506002 10.5581704,10.9617844 10.8012351,10.7325162 C10.9042562,10.6353427 10.9699234,10.5051077 10.986798,10.3644973 L12.1270761,0.86296258 C12.1668896,0.531210773 11.9302269,0.229997579 11.5984751,0.190184082 C11.5272834,0.181640375 11.4551398,0.185820007 11.385411,0.202527922 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4392124,1.43795818 L29.5975355,1.43795818 C30.2658001,1.43795818 30.8075355,1.97969364 30.8075355,2.64795818 C30.8075355,2.7073062 30.8031692,2.7665738 30.7944719,2.82528108 L28.8765599,15.7712602 C28.2612872,19.9243751 24.6964486,23 20.4980056,23 L5.61501494,23 L5.61501494,23",
    id: "\\u8DEF\\u5F84-3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.6816284,
    y1: 8.55692956,
    x2: 15.9428155,
    y2: 8.55692956,
    id: "\\u8DEF\\u5F84-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecharge);
export default __webpack_public_path__ + "static/media/icon_recharge.b6bb7f5ce2dce0696160bf78eb5bcd95.svg";
export { ForwardRef as ReactComponent };